import Boleto from "../pages/boleto";

export default [{ path: "/boleto", component: Boleto }];
